'use strict';

app.controller('RouteCtrl', [
    '$scope',
    '$rootScope',
    '$http',
    '$window',
    'uiGmapIsReady',
    '$log',
    '$translate',
    'toaster',
    '$timeout',
    '$interval',
    '$ngConfirm',
    'GoogleMapService',
    'ZoneShapeDrawing',
    'ZoneShapeGroupDrawing',
    'AccessManagerService',
    'DistributionService',
    'Microservice',
    '$q',
    function(
        $scope,
        $rootScope,
        $http,
        $window,
        uiGmapIsReady,
        $log,
        $translate,
        toaster,
        $timeout,
        $interval,
        $ngConfirm,
        GoogleMapService,
        ZoneShapeDrawing,
        ZoneShapeGroupDrawing,
        AccessManagerService,
        DistributionService,
        Microservice,
        $q
    ) {
        var $ctrl = {};

        /**
         * Object containing the renedered map object which allows to directly
         * control the map with pure Google Maps API. Initialized with uiGmapIsReady
         * service.
         */
        $scope.mapObject = {};

        $scope.goAndSearch = false;
        $scope.mobileListView = true;

        /**
         * Flag indicating whether show information about object
         */
        $scope.showObjectParameters = false;
        $scope.objectParameters = {
            distance: 0,
            average: 0,
            worktime: 0,
            rest: 0,
            speed: 0,
            number: false,
        };

        /* =====================================================================
         * Section: Sidebar
         * =================================================================== */

        /**
         * Flag indicating whether the sidebar is open
         */
        $scope.sidebarOpen = true;

        /**
         * $interval value
         */
        $scope.sidebarObjectsInterval = null;

        /**
         * Object containing startDate and endDate for background ajax request for newest route data
         */
        $scope.routeNextQuery = {};

        /**
         * Sidebar model object
         */
        $scope.roadData = {};

        $scope.showInfoToolbar = false;

        /**
         * User settings
         */
        $scope.maxAllowedSpeed = false;

        /**
         * Toggle info toolbar
         */
        $scope.toggleInfoToolbar = function() {
            $scope.showInfoToolbar = !$scope.showInfoToolbar;
        };

        $scope.toggleMobileList = function() {
            $scope.mobileListView = !$scope.mobileListView;
        };

        $scope.stopMarker = {
            idKey: 999,
            coords: {
                latitude: null,
                longitude: null,
            },
            options: {
                visible: false,
            },
            events: {},
            control: null,
            icon: null,
        };
        $scope.stopMarkers = [];

        /**
         * Function get all logged in user settings
         */
        $scope.getUserSettings = function() {
            var settings = $scope.app.user.userSettings;
            var speed = (((settings || {}).notifications || {}).speed || {}).value;

            if (typeof speed !== 'undefined') {
                speed = parseInt(speed);
                $scope.maxAllowedSpeed = speed > 0 ? speed : false;
            }
        };

        $scope.getStopMarkerObjectData = function() {
            return {
                address: '',
                args: false,
                start: $scope.currentTime,
                end: null,
                posX: $scope.currentX,
                posY: $scope.currentY,
                messageId: $scope.currentMessageId,
            };
        };

        $scope.setAddress = function(o) {
            return $http
                .get('/api/node/geocoding/get?lat=' + o.posY + '&lon=' + o.posX + '&cachable=1')
                .then(function(response) {
                    var address = response.data.data;
                    o.address = address.display_name;
                });
        };

        $scope.getTranslations = function() {
            var translations = {
                loading: $translate.instant('routes.loading'),
            };
            var objectFields = [
                'date',
                'vectorSpeed',
                'ignition',
                'fuelUsage',
                'business',
                'mileage',
                'rpm',
                'voltage',
                'fuelLevel',
                'ecoLevel',
                'ecoAlarm',
                'ecoQuality',
                'gasPedal',
                'fuelInputLevel',
                'fuelLevelCan',
            ];

            for (var index in objectFields) {
                var item = objectFields[index];
                translations[item] = $translate.instant('routes.params.' + item);
            }
            return translations;
        };

        /**
         * Toggle sidebar state
         */
        $scope.toggleSidebar = function() {
            $scope.sidebarOpen = !$scope.sidebarOpen;

            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 300);
        };

        $scope.selectedObject = {};
        $scope.selectedStop = {};

        $scope.objects = [];
        $scope.routeData = [];
        $scope.stops = [];
        $scope.fuelTankMarkers = [];
        $scope.fuelTanks = [];

        $scope.dateStart = moment()
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        $scope.dateEnd = moment()
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

        $scope.liveDateStart = $scope.dateStart;
        $scope.liveDateEnd = $scope.dateEnd;

        $scope.configo = {
            startView: 'day',
            modelType: 'YYYY-MM-DD HH:mm:ss',
        };

        /**
         * CSV export
         */

        $scope.triggerCsvExport = 0;

        $scope.csv = function() {
            $scope.triggerCsvExport++;
        };

        /**
         * Frequency filter - used for filtering records in route table
         */
        $scope.displayFrequencyFilterOptions = [1, 5, 15, 30, 60];

        $scope.displayFrequencyFilter = 1;

        $scope.frequencyFilter = 1;

        $scope.changeDisplayFrequencyFilter = function(selected) {
            $scope.frequencyFilter = selected;
        };

        /**
         * Player
         */
        var ROUTE_PLAYER_MODE_BACKWARD = -1;
        var ROUTE_PLAYER_MODE_STOP = 0;
        var ROUTE_PLAYER_MODE_FORWARD = 1;

        $scope.routePlayerMode = ROUTE_PLAYER_MODE_STOP;

        $scope.stopRoutePlayer = function() {
            $scope.routePlayerMode = ROUTE_PLAYER_MODE_STOP;
        };
        $scope.runRoutePlayer = function(back) {
            $scope.routePlayerMode = back ? ROUTE_PLAYER_MODE_BACKWARD : ROUTE_PLAYER_MODE_FORWARD;
        };
        $scope.isRoutePlayerRunning = function() {
            return $scope.routePlayerMode !== ROUTE_PLAYER_MODE_STOP;
        };
        $scope.isRoutePlayerInBackwardMode = function() {
            return $scope.routePlayerMode === ROUTE_PLAYER_MODE_BACKWARD;
        };
        $scope.isRoutePlayerInForwardMode = function() {
            return $scope.routePlayerMode === ROUTE_PLAYER_MODE_FORWARD;
        };

        /*
         * datetime picker hack
         */

        $scope.lastStartView = false;
        $scope.lastEndView = false;

        $scope.onDateChange = function(n, o, type) {
            if (n === void 0 || o === void 0) {
                return false;
            }
            var picker = angular.element(document.querySelectorAll('.moment-picker-container')[0]);
            var element = type === 'start' ? '.mp-start input' : '.mp-end input';
            var input = angular.element(document.querySelectorAll(element)[0]);

            if (picker.hasClass('open') && n.format('YYYY-MM-DD') !== o.format('YYYY-MM-DD')) {
                if (type === 'start') {
                    $scope.dateStart = n.startOf('day').format('YYYY-MM-DD HH:mm:ss');
                } else {
                    $scope.dateEnd = n.endOf('day').format('YYYY-MM-DD HH:mm:ss');
                }
                input[0].blur();
            } else {
                if (type === 'start') {
                    $scope.dateStart = n.format('YYYY-MM-DD HH:mm:ss');
                } else {
                    $scope.dateEnd = n.format('YYYY-MM-DD HH:mm:ss');
                }
            }
        };

        $scope.mapOverlays = [];

        /**
         * Prepares google maps icon configuration repeat value for performance optimalization
         *
         * @param {int} pointsCount
         * @returns {String}
         */
        $scope.getIconRepeatDensity = function(pointsCount) {
            if (pointsCount > 4000) {
                return '4000px';
            }
            if (pointsCount > 2000) {
                return '2000px';
            }
            if (pointsCount > 1000) {
                return '1000px';
            }
            if (pointsCount > 200) {
                return '500px';
            }
            return '100px';
        };

        $scope.clearMap = function() {
            for (var i = 0; i < $scope.mapOverlays.length; i++) {
                $scope.mapOverlays[i].setMap(null);
            }
            $scope.mapOverlays = [];
            $scope.clearOverlays($scope.fragment.overlays);
        };

        $scope.clearOverlays = function(ov) {
            for (var i = 0; i < ov.length; i++) {
                ov[i].setMap(null);
            }
            ov.splice(0, ov.length);
        };

        $scope.listEvents = [];

        $scope.clearData = function() {
            $scope.listEvents = [];
            $scope.$broadcast('$$rebind::refresh');
        };

        $scope.currentDateStart = null;
        $scope.currentDateEnd = null;
        $scope.currentObjectId = null;
        $scope.currentObjectNumber = null;
        $scope.typeOfCalculateWorktime = '';

        $scope.lastMessageId = false;
        $scope.currentMessageId = null;
        $scope.currentX = null;
        $scope.currentY = null;
        $scope.currentVectorAngle = null;
        $scope.currentIgnition = null;
        $scope.currentTime = null;
        $scope.centeringAllowed = false;

        $scope.currentObjectInfo = {};
        $scope.objectMarketWindowTab = 1;

        /**
         * Interactive map modes
         * - speed - click to see current vehicle speed
         * - fragment - show fragment of route after double click
         * - zone - @TODO
         */

        var MAP_INTERACTION_MODE_SPEED = 1;
        var MAP_INTERACTION_MODE_FRAGMENT = 2;

        $scope.mapInteractionMode = MAP_INTERACTION_MODE_SPEED;

        $scope.isMapInteractionModeSpeed = function() {
            return $scope.mapInteractionMode === MAP_INTERACTION_MODE_SPEED;
        };

        $scope.isMapInteractionModeFragment = function() {
            return $scope.mapInteractionMode === MAP_INTERACTION_MODE_FRAGMENT;
        };

        $scope.changeInteractionMode = function() {
            $scope.mapInteractionMode++;
            if ($scope.mapInteractionMode > MAP_INTERACTION_MODE_FRAGMENT) {
                $scope.mapInteractionMode = MAP_INTERACTION_MODE_SPEED;
            }
        };

        $scope.isMarketWindowTab = function(tab) {
            return $scope.objectMarketWindowTab === tab;
        };

        $scope.changeMarketWindowTab = function(tab) {
            $scope.objectMarketWindowTab = tab;
            if (tab === 2) {
                $scope.getCurrentObjectInfo();
            }
        };

        $scope.getCurrentObjectInfo = function() {
            var endpoint = `/api-react/object/${$scope.currentObjectId}/module/can?id=${$scope.currentMessageId}`;

            $http.get(endpoint).then(function(response) {
                $scope.currentObjectInfo = response.data.data;
            });
        };

        $scope.$watch('currentX', function(n, o) {
            if ($scope.currentX && o) {
                /**
                 * Avoid API requests during player mode
                 */
                !$scope.isRoutePlayerRunning() && $scope.getCurrentObjectInfo();
                $scope.createStopMarker(
                    $scope.currentX,
                    $scope.currentY,
                    $scope.currentIgnition,
                    $scope.currentVectorAngle,
                    false
                );
            }
        });

        $scope.getSecondsInFormat = function(seconds) {
            var days = Math.floor(seconds / (3600 * 24));
            var format =
                (days > 0 ? days + 'd ' : '') + new Date(seconds * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0];

            return format;
        };

        $scope.getObjectInformation = function() {
            var baseApiEndpoint = '/api/object/' + $scope.currentObjectId;
            var params = '?start=' + $scope.currentDateStart + '&end=' + $scope.currentDateEnd;

            $scope.showObjectParameters = false;

            $http.get(baseApiEndpoint + '/module/info').then(function(info) {
                $scope.objectParameters.number = info.data.data.data.Number;
                $scope.currentObjectNumber = $scope.objectParameters.number;
            });

            var type = '';
            if (typeof $scope.app.user.userSettings.distanceSource !== 'undefined') {
                type = $scope.app.user.userSettings.distanceSource;
            } else {
                type = 'auto';
            }

            $http
                .get(
                    '/api/node/object/calculateDistance?id=' +
                        $scope.currentObjectId +
                        '&start=' +
                        $scope.currentDateStart +
                        '&end=' +
                        $scope.currentDateEnd +
                        '&type=' +
                        type
                )
                .then(function(response) {
                    var distance = response.data.data.distance;
                    return distance;
                })
                .then(function(distance) {
                    if (distance == 0) {
                        return { fuel: 0, fuelInput: 0, distance: 0 };
                    }
                    return $http
                        .get(
                            '/api/node/object/fuel-usages?many=1&object=' +
                                $scope.currentObjectId +
                                '&start=' +
                                $scope.currentDateStart +
                                '&end=' +
                                $scope.currentDateEnd
                        )
                        .then(function(response) {
                            return {
                                fuel: response.data.data.fuel,
                                fuelInput: response.data.data.fuelInput,
                                distance: distance,
                            };
                        });
                })
                .then(function(response) {
                    return {
                        fuel: response.fuel,
                        fuelInput: response.fuelInput,
                        distance: response.distance,
                        average: response.distance > 0 ? (response.fuel * 100) / response.distance : 0,
                        averageInput: response.distance > 0 ? (response.fuelInput * 100) / response.distance : 0,
                    };
                })
                .then(function(average) {
                    $scope.objectParameters.distance = average.distance;
                    $scope.objectParameters.average = average.average;
                    $scope.objectParameters.averageInput = average.averageInput;
                    $http
                        .get('/api/worktimeSetting/' + $scope.currentObjectId)
                        .then(function(response) {
                            $scope.typeOfCalculateWorktime = response.data.data.type;
                        })
                        .then(function() {
                            var payload =
                                params +
                                '&object=' +
                                $scope.currentObjectId +
                                '&type=' +
                                $scope.typeOfCalculateWorktime;
                            $http.get('/api/node/object/worktime' + payload).then(function(response) {
                                var worktime = response.data.data;
                                var hours = worktime.value / 3600;
                                var speed = hours > 0 ? $scope.objectParameters.distance / hours : 0;

                                var start = moment.utc($scope.currentDateStart);
                                var end = moment.utc($scope.currentDateEnd);
                                var time = end.diff(start, 'seconds');

                                $scope.objectParameters.worktime = worktime.value;
                                $scope.objectParameters.rest = time - worktime.value;
                                $scope.objectParameters.speed = speed;
                                $scope.objectParameters.number = $scope.objectParameters.number
                                    ? $scope.objectParameters.number
                                    : false;
                                $scope.showObjectParameters = true;
                            });
                        });
                });
        };

        $scope.handlePolyLineClick = function(event, polyline, points) {
            var latlng = event.latLng;
            var needle = {
                minDistance: 9999999999,
                index: -1,
                latlng: null,
            };
            polyline.getPath().forEach(function(point, index) {
                var dist = google.maps.geometry.spherical.computeDistanceBetween(latlng, point);
                if (dist < needle.minDistance) {
                    needle.minDistance = dist;
                    needle.index = index;
                    needle.latlng = point;
                }
            });

            if (points[needle.index] !== void 0) {
                if ($scope.isMapInteractionModeFragment()) {
                    /**
                     * Fragment mode
                     * ---
                     * Take two points, draw polygons beetween and
                     * get other information
                     */
                    var start = $scope.fragment.start;
                    var end = $scope.fragment.end;

                    if (start && end) {
                        start = false;
                        end = false;
                    }

                    if (!start) {
                        start = needle.index;
                        $scope.clearOverlays($scope.fragment.overlays);
                        $scope.drawRouteFragmentPoint(start);
                    } else {
                        end = needle.index;
                        $scope.drawRouteFragmentPoint(end);
                    }

                    if (start && end && start > end) {
                        var tmp = start;
                        start = end;
                        end = tmp;
                    }

                    $scope.fragment.start = start;
                    $scope.fragment.end = end;

                    if (start && end) {
                        $scope.drawRouteFragment();
                        $scope.drawRouteFragmentPoint(start);
                        $scope.drawRouteFragmentPoint(end);
                    }
                }

                if ($scope.isMapInteractionModeSpeed()) {
                    /**
                     * Speed mode
                     * ---
                     * Display only one toaster at time to avoid too many
                     * information windows
                     */
                    var now = moment.utc();
                    var isTodayPoint = now.isSame(points[needle.index].date, 'day');

                    toaster.pop(
                        'info',
                        points[needle.index].date.format(isTodayPoint ? 'HH:mm:ss' : 'YYYY-MM-DD HH:mm:ss'),
                        $translate.instant('routes.messages.speed') + ' - ' + points[needle.index].speed + ' km/h'
                    );
                }
            }
        };

        $scope.routes = [];

        $scope.fragment = {
            start: false,
            end: false,
            overlays: [],
        };
        $scope.fragmentInitial = angular.copy($scope.fragment);

        $scope.resetRouteFragment = function() {
            $scope.fragment = angular.copy($scope.fragmentInitial);
        };

        $scope.getRouteFragmentStatistics = function(is, ie, speed) {
            var start = $scope.routes[is];
            var end = $scope.routes[ie];
            var type = '';

            if (typeof $scope.app.user.userSettings.distanceSource !== 'undefined') {
                type = $scope.app.user.userSettings.distanceSource;
            } else {
                type = 'auto';
            }

            return $http
                .get(
                    '/api/node/object/calculateDistance?id=' +
                        $scope.currentObjectId +
                        '&start=' +
                        start.GpsTime +
                        '&end=' +
                        end.GpsTime +
                        '&type=' +
                        type
                )
                .then(function(response) {
                    var distance = response.data.data.distance;
                    return {
                        speed: speed,
                        distance: typeof distance === void 0 ? 0.0 : distance,
                    };
                });
        };

        $scope.drawRouteFragmentPoint = function(index) {
            var point = $scope.routes[index];
            var center = { lat: point.Y, lng: point.X };

            var circle = new google.maps.Marker({
                map: $scope.mapObject,
                position: center,
                title: 'circle',
                icon: {
                    strokeColor: '#ee4036',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    fillColor: '#ee4036',
                    fillOpacity: 1.0,
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 5,
                    anchor: new google.maps.Point(0, 0),
                },
            });
            $scope.fragment.overlays.push(circle);
        };

        $scope.drawRouteFragment = function() {
            var points = $scope.routes.map(function(v) {
                return {
                    lat: v.Y,
                    lng: v.X,
                    speed: v.VectorSpeed,
                    date: moment.utc(v.GpsTime),
                };
            });

            $scope.clearOverlays($scope.fragment.overlays);

            var maxSpeed = 0;

            for (var i = 0; i < points.length - 1; i++) {
                if (i < $scope.fragment.start || i > $scope.fragment.end - 1) {
                    continue;
                }

                maxSpeed = points[i].speed > maxSpeed ? points[i].speed : maxSpeed;

                var pl = new google.maps.Polyline({
                    path: [points[i], points[i + 1]],
                    geodesic: false,
                    clickable: false,
                    strokeColor: '#23b7e5',
                    strokeOpacity: 1.0,
                    strokeWeight: 5,
                    zIndex: 2,
                    map: $scope.mapObject,
                });
                $scope.fragment.overlays.push(pl);
            }

            $scope.getRouteFragmentStatistics($scope.fragment.start, $scope.fragment.end, maxSpeed).then(
                function(data) {
                    var distance = Math.round(data.distance * 100) / 100;
                    toaster.pop(
                        'info',
                        $translate.instant('routes.messages.fragment.speed') + ' - ' + data.speed + ' km/h',
                        $translate.instant('routes.messages.fragment.distance') + ' - ' + distance + ' km'
                    );
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('routes.messages.fragment.toastr')
                    );
                }
            );
        };

        $scope.expandedViewForObject = function(object, mobile) {
            $scope.selectedObject = object;
            if (!$scope.selectedObject.hasOwnProperty('objectId')) {
                toaster.pop(
                    'info',
                    $translate.instant('routes.messages.noObject.title'),
                    $translate.instant('routes.messages.noObject.body')
                );
                return;
            }
            $scope.closeWindow();
            $scope.clearData();
            $scope.currentDateStart = $scope.selectedObject.dateStart;
            $scope.currentDateEnd = $scope.selectedObject.dateEnd;
            $scope.currentObjectId = $scope.selectedObject.objectId;

            if ($window.ga) {
                $window.ga(
                    'send',
                    'event',
                    'generateRoute',
                    $scope.selectedObject.objectId,
                    $scope.selectedObject.dateStart + ' to ' + $scope.selectedObject.dateEnd
                );
            }

            /**
             * ww-route-component logic
             */

            $scope.goAndSearch = false;

            var settings = $rootScope.app.user.userSettings;
            var refuellingDisabledObjects = (((settings.fuel || {}).tanks || {}).objects || '')
                .split(',')
                .filter(function(o) {
                    return o;
                })
                .map(function(o) {
                    return Number(o);
                });

            var nowMoment = moment();
            var endMoment = moment($scope.currentDateEnd);

            if (endMoment > nowMoment) {
                $scope.currentDateEnd = nowMoment.format('YYYY-MM-DD HH:mm:ss');
            }

            var routePromise = null;

            if ($scope.trackObjectsRouteSimple[$scope.selectedObject.objectId] !== void 0) {
                routePromise = new Promise(function(resolve, reject) {
                    return resolve({ data: { data: $scope.trackObjectsRouteSimple[$scope.selectedObject.objectId] } });
                });
            } else {
                var endpoint = `/api/object/${$scope.selectedObject.objectId}/routeSimple`;

                routePromise = $http.get(endpoint, {
                    params: {
                        start: $scope.selectedObject.dateStart,
                        end: $scope.selectedObject.dateEnd,
                    },
                });
            }

            var fuelTanksPromise =
                refuellingDisabledObjects.indexOf($scope.selectedObject.objectId) >= 0
                    ? { data: { data: { data: [], tanks: [] } } }
                    : $http.get(
                          '/api/node/object/fuel-tank?source=auto&object=' +
                              $scope.selectedObject.objectId +
                              '&start=' +
                              $scope.selectedObject.dateStart +
                              '&end=' +
                              $scope.selectedObject.dateEnd
                      );

            Promise.all([routePromise, fuelTanksPromise])
                .then(function(response) {
                    $scope.clearMap();
                    var routeData = response[0].data.data;

                    if (routeData.route.length == 0 && routeData.stops.length == 0) {
                        toaster.pop(
                            'info',
                            $translate.instant('routes.messages.noDatas.title'),
                            $translate.instant('routes.messages.noDatas.body')
                        );
                        return;
                    }

                    var fuelData = response[1].data.data;

                    $scope.stops = routeData.stops;
                    $scope.routes = routeData.route;
                    $scope.fuelTanks = fuelData.tanks;

                    var points = routeData.route.map(function(v) {
                        return {
                            lat: v.Y,
                            lng: v.X,
                            speed: v.VectorSpeed,
                            date: moment.utc(v.GpsTime),
                        };
                    });

                    /**
                     * handle arrows seperately
                     *
                     * @type google.maps.Polyline
                     */

                    var directions = new google.maps.Polyline({
                        path: points,
                        geodesic: true,
                        strokeOpacity: 1,
                        strokeWeight: 2,
                        strokeColor: '#0000FF',
                        icons: [
                            {
                                repeat: $scope.getIconRepeatDensity(points.length),
                                icon: {
                                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                    scale: 4,
                                    strokeColor: '#0000FF',
                                    strokeOpacity: 1,
                                    strokeWeight: 2,
                                    fillColor: '#0000FF',
                                    fillOpacity: 1,
                                },
                            },
                        ],
                    });

                    /*
                     * use loop for colour polylines fragments
                     * orange colour is for crossing max allowed speed read from login configuration
                     *
                     * @type google.maps.Polyline
                     */

                    if ($scope.maxAllowedSpeed) {
                        var overspeeds = [];
                        var ospeed = [];

                        for (var i = 0; i < points.length - 1; i++) {
                            if (points[i].speed <= $scope.maxAllowedSpeed) {
                                if (ospeed.length > 0) {
                                    if (ospeed.length === 1) {
                                        ospeed.push(points[i]);
                                    }
                                    overspeeds.push(ospeed.slice());
                                    ospeed = [];
                                }
                                continue;
                            }
                            ospeed.push(points[i]);
                        }

                        /*
                         * each polyline is unclickable for performance reason
                         * and because of override proper event handler in another
                         * main poyline
                         */

                        for (var i = 0; i < overspeeds.length - 1; i++) {
                            var pl = new google.maps.Polyline({
                                path: overspeeds[i],
                                geodesic: true,
                                clickable: false,
                                strokeColor: '#FF0000',
                                strokeOpacity: 1.0,
                                strokeWeight: 5,
                            });
                            pl.setMap($scope.mapObject);
                            $scope.mapOverlays.push(pl);
                        }
                    }

                    /*
                     * decided to bind one event to one complex polyline instead
                     * thousands of event to each line seperately, it will be also
                     * better because this polyline is invisible and we can make
                     * lines more wider and easier to click...
                     * it require some calculations for nearest clicked point
                     */

                    google.maps.event.addListener(directions, 'click', function(e) {
                        $scope.handlePolyLineClick(e, this, points);
                    });

                    directions.setMap($scope.mapObject);
                    $scope.mapOverlays.push(directions);

                    $scope.generateMarkers();

                    // collect all current routes
                    var bound = new google.maps.LatLngBounds();
                    for (var i = 0; i < routeData.route.length; i++) {
                        var object = routeData.route[i];
                        bound.extend({ lat: object.Y, lng: object.X });
                    }

                    // fit map bounds to rectangle of all route bounds
                    $scope.mapObject.fitBounds(bound);

                    $scope.resetRouteFragment();

                    var last = routeData.route[routeData.route.length - 1];

                    $scope.currentX = last.X;
                    $scope.currentY = last.Y;
                    $scope.currentVectorAngle = last.VectorAngle;
                    $scope.currentIgnition = last.VectorSpeed;
                    $scope.currentTime = moment.utc(last.GpsTime).format('YYYY-MM-DD HH:mm:ss');
                    $scope.currentMessageId = last.MessageId;
                    $scope.goAndSearch = true;
                    $scope.createStopMarker(last.X, last.Y, last.VectorSpeed, last.VectorAngle, true);
                })
                .catch(function(response) {
                    $log.error(response);
                });

            $scope.resetChartSection();
            $scope.getObjectInformation();
        };

        $scope.getObjects = function() {
            $scope.closeWindow();
            $scope.objects = angular.copy($scope.extractObjectsBySelectedGroup(false, true));
        };

        /**
         * Hack for multiselect single limitation
         */
        var lock = false;

        function resetTracking() {
            $scope.objectToTrack = null;
            if ($scope.objectsToTrack && $scope.objectsToTrack.length) {
                $scope.objectToTrack = $scope.objectsToTrack[0];
                if ($scope.trackObjects[$scope.objectToTrack.objectId] !== void 0) {
                    $scope.objectToTrack = $scope.trackObjects[$scope.objectToTrack.objectId];
                }
            }
        }

        $scope.$watch(
            'objectsToTrack',
            function() {
                if (!Array.isArray($scope.objectsToTrack)) {
                    return;
                }
                if (!lock) {
                    if ($scope.objectsToTrack.length < 2) {
                        resetTracking();
                        return false;
                    }
                    var stored = $scope.objectsToTrack[$scope.objectsToTrack.length - 1].objectId;
                    lock = true;

                    $timeout(function() {
                        $scope.objectsToTrack = $scope.objects.filter(function(o) {
                            return o.objectId === stored;
                        });

                        resetTracking();
                        lock = false;
                    }, 10);
                }
            },
            false
        );

        /**
         * Map settings
         */
        $scope.map = GoogleMapService.defaults(['cluster']);

        /**
         * The 'map is ready' logic
         */
        $scope.gMapPromise = function() {
            uiGmapIsReady.promise().then(function() {
                GoogleMapService.set($scope.map);

                fireGoogleMapLoad(GoogleMapService.get());
            });
        };

        /**
         * Init
         =======

         /**
         * Get map center
         * @returns {object}
         */
        $scope.getMapCenter = function() {
            return $scope.map.center;
        };

        /*
         * Return the current scale of the map.
         * @param {int} zoom
         */
        $scope.getMapScale = function(zoom) {
            return Math.pow(2, zoom);
        };

        /**
         * Get map zoom
         * @return {int}
         */
        $scope.getMapZoom = function() {
            return $scope.map.zoom;
        };

        /**
         * Pan the map to the given point
         * @param {float} lat
         * @param {flaot} lng
         */
        $scope.panMapTo = function(lat, lng) {
            $scope.mapObject.panTo({
                lat: lat,
                lng: lng,
            });
        };

        /**
         * Set center of the map
         * @param {float} lat
         * @param {float} lng
         */
        $scope.setMapCenter = function(lat, lng) {
            $scope.map.center = {
                latitude: lat,
                longitude: lng,
            };
        };

        /**
         * Set zoom map level
         * @param {int} zoom
         */
        $scope.setMapZoom = function(zoom) {
            $scope.map.zoom = zoom;
        };

        /**
         * Center map on the given object. Action trigger after clicking
         * the stop object in the sidebar.
         * @param {stop} object
         */
        $scope.centerMapOnStop = function(stop, zoom) {
            zoom = zoom !== void 0 ? zoom : 14;

            $scope.selectedStop = Object.assign($scope.selectedStop, stop);
            /**
             * Avoid API requests during player mode
             */
            if (!$scope.isRoutePlayerRunning()) {
                $scope.setAddress($scope.selectedStop);
            }

            /**
             * Set map zoom + window coords
             * Centerize on coords
             */
            $scope.setMapZoom(zoom);
            $scope.setWindowCoords(stop.posY, stop.posX);

            centerizeOnObject(stop.posY, stop.posX);
        };

        var centerizeOnObject = function(lat, lng) {
            /**
             * Using timeout for angularjs map queue
             */
            $timeout(function() {
                var box = angular.element('.box-object-market-window');
                var offset = box.length ? box.height() : 0;

                var latLng = $scope.offsetPoint(lat, lng, 0, -offset, $scope.getMapZoom());
                $scope.panMapTo(latLng.lat(), latLng.lng());
            }, 300);
        };

        /* =====================================================================
         * Section: Markers
         * =================================================================== */

        /**
         * All stop markers visible on map
         */
        $scope.markers = [];

        /**
         * Generate all stop markers visible on the map
         */
        $scope.generateMarkers = function() {
            $scope.markers = [];
            $scope.fuelTankMarkers = [];

            for (var i = 0; i < $scope.stops.length; i++) {
                var o = $scope.stops[i];
                var marker = {
                    id: i,
                    messageId: o.messageId,
                    type: 'stop',
                    latitude: o.posY,
                    longitude: o.posX,
                    markerOptions: {
                        label: {
                            text: 'P' + String(i + 1),
                            fontWeight: 'bold',
                            fontSize: '9px',
                            color: '#fff',
                        },
                    },
                };
                $scope.markers.push(marker);
            }

            for (var i = 0; i < $scope.fuelTanks.length; i++) {
                var o = $scope.fuelTanks[i];

                if (!o.FuelTanks.Before) {
                    continue;
                }
                var oBeforeTank = o.FuelTanks.Before;

                var marker = {
                    id: i,
                    messageId: o.MessageId,
                    type: 'fuel',
                    latitude: o.Y,
                    longitude: o.X,
                    start: oBeforeTank.GpsTime,
                    args: o.FuelTanks,
                    markerOptions: {
                        label: {
                            text: 'T' + String(i + 1),
                            fontWeight: 'bold',
                            fontSize: '10px',
                            color: '#fff',
                        },
                        icon: {
                            path:
                                'M39.545,0H4.72C2.706,0,1.072,1.634,1.072,3.648v74.427h42.116V3.648   C43.188,1.634,41.562,0,39.545,0z M37.945,27.827H6.323V7.115h31.623V27.827z M59.926,79.536c-8.647,0-13.888-5.95-14.385-16.321   c-0.207-4.091,0.818-8.591,1.9-13.36c0.813-3.583,1.662-7.28,2.061-11.083c0.399-3.814-0.201-5.111-0.595-5.546   c-0.73-0.813-2.879-0.813-4.956-0.813h-1.022v-5.056h1.022c3.035,0,6.479,0,8.715,2.486c1.75,1.937,2.341,4.947,1.869,9.46   c-0.43,4.091-1.305,7.954-2.153,11.682c-1,4.417-1.952,8.596-1.792,11.982c0.367,7.643,3.511,11.512,9.336,11.512   c6.4,0,9.647-4.045,9.647-12.02c0-6.597-2.051-11.733-3.413-15.13l-0.533-1.367c-1.413-3.702-1.6-7.021-1.745-12.052   c-0.145-4.883-0.088-10.105,1.264-15.266c1.362-5.19,4.163-7.72,8.798-11.909l1.118-1.018l3.402,3.744l-1.134,1.023   c-4.334,3.922-6.312,5.711-7.291,9.447c-1.191,4.536-1.228,9.328-1.104,13.831c0.141,4.908,0.332,7.539,1.419,10.397l0.508,1.284   c1.419,3.531,3.77,9.435,3.77,17.005C74.627,73.151,69.128,79.536,59.926,79.536z M66.435,34.769l-0.129-5.059   c0,0,3.92-0.101,6.142-0.127c0.051-0.896,0.051-2.296,0.051-3.764v-0.754c0-6.05-0.947-6.851-2.034-7.785   c-0.399-0.334-0.793-0.684-1.176-1.103l3.718-3.418c0.238,0.259,0.497,0.466,0.74,0.673c2.16,1.843,3.807,3.866,3.807,11.627v0.753   c0,2.835,0.005,4.401-0.249,5.592c-0.435,2.048-1.843,3.226-3.862,3.226C71.8,34.631,66.441,34.769,66.435,34.769z',
                            fillColor: '#3cb371',
                            fillOpacity: 1,
                            strokeWeight: 1,
                            strokeColor: '#333',
                            scale: 0.4,
                            anchor: new google.maps.Point(25, 0),
                            labelOrigin: new google.maps.Point(25, 50),
                        },
                    },
                };
                $scope.fuelTankMarkers.push(marker);
            }

            // Recalulate bounds
            $scope.calculateBounds();
        };

        /**
         * Show object location in Google Maps
         * @param {object} object
         */
        $scope.openInGoogleMaps = function(object) {
            var url = 'https://maps.google.com/maps?q=' + object.posY + '+' + object.posX;

            if ($scope.app.isMobile) {
                $window.location.href = url;
            } else {
                $window.open(url, 'google');
                return false;
            }
        };

        $scope.openSelectedObjectWindow = function(object) {
            $scope.setAddress(object);

            /**
             * Set window coords
             * Centerize object on coords
             */
            $scope.setWindowCoords(object.posY, object.posX);
            $scope.openWindow();

            centerizeOnObject(object.posY, object.posX);
        };

        $scope.prepareFuelObject = function(o) {
            return {
                address: '',
                args: o.args,
                start: moment.utc(o.start, 'YYYY-MM-DDTHH:mm:ss0Z').format('YYYY-MM-DD HH:mm:ss'),
                end: '',
                messageId: o.messageId,
                posX: o.longitude,
                posY: o.latitude,
                visibleSatelites: 0,
            };
        };

        /*
         * Handles the marker click action
         * @param {object} googleMarker
         * @param {string} eventName
         * @param {object} marker
         */
        $scope.markerClick = function(gm, en, marker) {
            var object = marker.type === 'stop' ? $scope.stops[marker.id] : $scope.prepareFuelObject(marker);

            if (!$scope.lastMessageId) {
                $scope.lastMessageId = $scope.currentMessageId;
            }

            $scope.currentMessageId = object.messageId;
            $scope.getCurrentObjectInfo();

            object.args || (object.args = false);

            $scope.selectedStop = object;
            $scope.openSelectedObjectWindow(object);
        };

        $scope.stopMarker.click = function() {
            if ($scope.lastMessageId) {
                $scope.currentMessageId = $scope.lastMessageId;
                $scope.lastMessageId = false;
            }

            if (!$scope.currentMessageId) {
                return false;
            }

            var object = $scope.getStopMarkerObjectData();

            $scope.getCurrentObjectInfo();

            $scope.selectedStop = object;
            $scope.openSelectedObjectWindow(object);
        };

        /* =====================================================================
         * Section: Selected object info window
         * =================================================================== */

        /**
         * Selected object window options
         */
        $scope.windowOptions = {
            boxClass: 'box-object-market-window box-object-information-window',
            zIndex: 2,
            disableAutoPan: true,
        };

        $scope.showWindowColumn = function(col) {
            return typeof $scope.selectedStop[col] !== 'undefined' && $scope.selectedStop[col];
        };

        /**
         * Close selected object info window
         */
        $scope.closeWindow = function(centerize) {
            $scope.windowOptions.show = false;

            centerize = centerize !== void 0 ? centerize : false;
            if (centerize) {
                centerizeOnObject($scope.windowOptions.coords.latitude, $scope.windowOptions.coords.longitude);
            }
        };

        /**
         * Open selected object info window
         */
        $scope.openWindow = function() {
            $scope.windowOptions.show = true;
        };

        /**
         * Set selected object info window coordinates
         * @param {float} lat
         * @param {float} lng
         */
        $scope.setWindowCoords = function(lat, lng) {
            $scope.windowOptions.coords = {
                latitude: lat,
                longitude: lng,
            };
        };

        /* =====================================================================
         * Section: Bounds and clusters
         * =================================================================== */

        /**
         * Calculate object bounds
         */
        $scope.calculateBounds = function() {
            var boundWidth = 60;
            var scale = $scope.getMapScale($scope.mapObject.getZoom());

            for (var i = 0; i < $scope.routeData.route; i++) {
                var object = $scope.routeData.route[i];
                var position = $scope.latLngToPoint(object.y, object.x);
                object.bounds = {
                    left: position.x * scale - boundWidth / 2,
                    top: position.y * scale - boundWidth / 2,
                    right: position.x * scale + boundWidth / 2,
                    bottom: position.y * scale + boundWidth / 2,
                };
                object.cluster = null;
            }

            // Set object clusters
            $scope.objects.forEach($scope.calculateObjectClusters);
        };

        /**
         * Calculate object cluster
         * @param {object} object
         */
        $scope.calculateObjectClusters = function(object) {
            // Check if object is not already grouped
            if (object.cluster !== null) {
                return;
            }

            for (var key in $scope.objects) {
                var nextObject = $scope.objects[key];
                // Check if it's not the same object, and escound object is not already grouped
                if (nextObject.cluster === null && nextObject.objectId !== object.objectId) {
                    if (intersectRect(object.bounds, nextObject.bounds)) {
                        // Set object cluster
                        object.cluster = object.objectId;
                        nextObject.cluster = object.objectId;
                    }
                }
            }
        };

        /* =====================================================================
         * Section: Scope helper functions
         * =================================================================== */

        /*
         * Offset a point with given latitude and longitude by X any Y pixels.
         * @param {float} lat
         * @param {float} lng
         * @param {int} offsetX
         * @param {int} offsetY
         * @param {int} zoom
         */
        $scope.offsetPoint = function(lat, lng, offsetX, offsetY, zoom) {
            if (zoom === false || typeof zoom === 'undefined') {
                zoom = $scope.mapObject.getZoom();
            }
            var scale = $scope.getMapScale(zoom);
            var worldCoordinateCenter = $scope.latLngToPoint(lat, lng);
            var pixelOffset = new google.maps.Point(offsetX / scale || 0, offsetY / scale || 0);
            var worldCoordinateNewCenter = new google.maps.Point(
                worldCoordinateCenter.x - pixelOffset.x,
                worldCoordinateCenter.y + pixelOffset.y
            );
            return $scope.mapObject.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
        };

        /*
         * Converts given latitude i longitude to a point on the map projection.
         * @param {float} lat
         * @param {float} lng
         */
        $scope.latLngToPoint = function(lat, lng) {
            var latLng = new google.maps.LatLng(lat, lng);
            return $scope.mapObject.getProjection().fromLatLngToPoint(latLng);
        };

        $scope.generateCarMarkerImage = function(rotation, color, stroke) {
            return {
                path:
                    'M45.6,16.9l0-11.4c0-3-1.5-5.5-4.5-5.5L3.5,0C0.5,0,0,1.5,0,4.5l0,13.4c0,3,0.5,4.5,3.5,4.5l37.6,0 C44.1,22.4,45.6,19.9,45.6,16.9z M31.9,21.4l-23.3,0l2.2-2.6l14.1,0L31.9,21.4z M34.2,21c-3.8-1-7.3-3.1-7.3-3.1l0-13.4l7.3-3.1 C34.2,1.4,37.1,11.9,34.2,21z M6.9,1.5c0-0.9,2.3,3.1,2.3,3.1l0,13.4c0,0-0.7,1.5-2.3,3.1C5.8,19.3,5.1,5.8,6.9,1.5z M24.9,3.9 l-14.1,0L8.6,1.3l23.3,0L24.9,3.9z',
                rotation: parseFloat(rotation) - 90,
                fillColor: color,
                fillOpacity: 1,
                scale: 0.5,
                strokeColor: stroke,
                strokeWeight: 1,
                anchor: new google.maps.Point(20, 10),
            };
        };

        $scope.createStopMarker = function(x, y, ignition, angle, reloaded) {
            $scope.stopMarker.coords = {
                latitude: y,
                longitude: x,
            };

            $scope.stopMarker.icon =
                ignition > 0
                    ? $scope.generateCarMarkerImage(angle, '#2CCB3B', '#00910')
                    : $scope.generateCarMarkerImage(angle, '#CA2742', '#C9001E');
            $scope.stopMarker.options.visible = true;

            $scope.selectedStop = $scope.getStopMarkerObjectData();

            if (!reloaded) {
                $scope.centerMapOnStop({ posX: x, posY: y }, 14);
            }
        };

        /**
         * routes chart section
         */

        $scope.getChartProperties = function() {
            /*
             * not added dins / cans
             * vectorAngle | mileage | rpm | voltage | ecoLevel | ecoAlarm
             */
            return ['vectorSpeed', 'ignition', 'fuelUsage', 'fuelLevel'];
        };

        $scope.$on('angular-resizable.resizeEnd', function(event, args) {
            $scope.$broadcast('ww-resizable-event');
        });

        $scope.chart = {
            properties: $scope.getChartProperties(),
            property: 'vectorSpeed',
            routes: [],
            collapsed: true,
            initialize: false,
            options: {
                title: {
                    text: '',
                },
                xAxis: {
                    type: 'datetime',
                },
                yAxis: {
                    title: {
                        text: '',
                    },
                },
                time: {
                    useUTC: false,
                },
                plotOptions: {
                    series: {
                        events: {
                            click: function(event) {
                                var point = event.point.series.userOptions.data[event.point.index][2];
                                $scope.createStopMarker(point.x, point.y, point.ignition, point.vectorAngle, false);
                            },
                        },
                    },
                },
                series: [
                    {
                        name: '',
                        data: [],
                    },
                ],
            },
            series: [
                {
                    data: [],
                },
            ],
        };

        $scope.resetChartSection = function() {
            $scope.chart.initialize = false;
            $scope.chart.routes = [];
            $scope.chart.collapsed = true;
        };

        $scope.toggleChartSection = function() {
            var route = window.routeWWComponentData;
            if (!$scope.chart.initialize && route) {
                $scope.chart.routes = route;
                $scope.chart.initialize = true;
            }
            if ($scope.chart.initialize) {
                $scope.chart.collapsed = !$scope.chart.collapsed;
                $scope.setChartSeriesProperty('vectorSpeed');
            }
            window.dispatchEvent(new Event('resize'));
        };

        /**
         * Calculate widths / heights and fit charts and map to content
         */
        var chartsInterval = $interval(function() {
            var height = Math.round(angular.element('.fi-mr-charts').outerHeight());
            var style = 'calc(100% - ' + height + 'px)';

            angular.element('.fi-mr-map').css({ height: style });

            var width = Math.round(angular.element('.rpc-header').outerWidth());
            angular.element('.fi-mr-charts .rg-top').css({
                'margin-left': width,
                width: 'calc(100% - ' + width + 'px)',
            });
        }, 10);

        $scope.$on('$destroy', function() {
            $interval.cancel(chartsInterval);
        });

        $scope.setChartSeriesProperty = function(k) {
            $scope.chart.property = k;

            var results = [];
            var data = $scope.chart.routes;

            for (var i = 0; i < data.length; i++) {
                var v = data[i][k];
                if (i > 0 && i < data.length - 1) {
                    if (v === data[i - 1][k] && v === data[i + 1][k]) {
                        continue;
                    }
                }
                var date = moment(data[i].date, 'YYYY-MM-DD HH:mm:ss');
                results.push([date.valueOf(), Number(v), data[i]]);
            }

            $scope.chart.series = [
                {
                    data: results,
                },
            ];
        };

        /* =====================================================================
         * Section: Many routes
         * =================================================================== */
        $scope.objectToTrack = null;
        $scope.objectsToTrack = null;
        $scope.trackObjects = {};
        $scope.selectedObject = null;
        $scope.amounTrackObjects = 0;
        $scope.trackObjectsRouteSimple = {};
        $scope.trackObjectsPolyline = {};
        $scope.trackObjectsMarkers = {};

        var USED_LABEL = [];
        var MAX_AMOUNT_OBJECTS = 10;
        var MAX_DATE_RANGE = 1;
        var ROUTES_DRAW_COLOR = [
            '#2a366b',
            '#006b44',
            '#40006b',
            '#ed9600',
            '#00baed',
            '#ed0000',
            '#940377',
            '#ff008f',
            '#127800',
            '#9000fa',
        ];

        $scope.searchRoutesForChoosenObjects = function(object, draw) {
            if (moment($scope.dateEnd).diff($scope.dateStart, 'month', true) > MAX_DATE_RANGE) {
                toaster.pop(
                    'error',
                    $translate.instant('routes.messages.maxRange.title'),
                    $translate.instant('routes.messages.maxRange.body')
                );
                return false;
            }

            if ($scope.trackObjects[object.objectId] === undefined && $scope.amounTrackObjects >= MAX_AMOUNT_OBJECTS) {
                toaster.pop(
                    'error',
                    $translate.instant('routes.messages.maxAmount.title'),
                    $translate.instant('routes.messages.maxAmount.body')
                );
                return false;
            }

            $scope.liveDateStart = angular.copy($scope.dateStart);
            $scope.liveDateEnd = angular.copy($scope.dateEnd);

            var draw = draw === void 0 || draw;

            if ($scope.trackObjects[object.objectId] === undefined) {
                $scope.amounTrackObjects += 1;
                $scope.trackObjects[object.objectId] = object;
                $scope.trackObjects[object.objectId].label = $scope.findLabelForObject();
                $scope.trackObjects[object.objectId].color =
                    ROUTES_DRAW_COLOR[$scope.trackObjects[object.objectId].label];
                $scope.trackObjects[object.objectId].isActual = false;
                $scope.trackObjects[object.objectId].dateStart = $scope.dateStart;
                $scope.trackObjects[object.objectId].dateEnd = $scope.dateEnd;
                $scope.trackObjects[object.objectId].isShow = true;
                return $scope.drawRoutesForObject(object, draw);
            } else {
                if (
                    $scope.trackObjects[object.objectId].dateStart !== $scope.dateStart ||
                    $scope.trackObjects[object.objectId].dateEnd !== $scope.dateEnd
                ) {
                    $scope.trackObjects[object.objectId].dateStart = $scope.dateStart;
                    $scope.trackObjects[object.objectId].dateEnd = $scope.dateEnd;
                    $scope.trackObjects[object.objectId].isShow = true;
                    return $scope.drawRoutesForObject(object, draw);
                }
            }

            return false;
        };

        $scope.easyObjectPreview = function() {
            $scope.dateStart = $scope.liveDateStart;
            $scope.dateEnd = $scope.liveDateEnd;

            var promise = $scope.searchRoutesForChoosenObjects($scope.objectToTrack, false);

            if (typeof promise === 'boolean') {
                return promise;
            }

            return promise.then(function() {
                $scope.goToExpandedViewForObject($scope.objectToTrack);
            });
        };

        $scope.goToExpandedViewForObject = function(object) {
            $scope.markers = [];
            $scope.fuelTankMarkers = [];

            $scope.expandedViewForObject(object);
        };

        $scope.backFromExpandedViewForObject = function() {
            new Promise(function(resolve, reject) {
                $scope.fuelTankMarkers = [];
                $scope.markers = [];
                $scope.selectedObject = null;
                $scope.goAndSearch = false;
                $scope.stopMarker.options.visible = false;

                resolve(true);
            }).then(function() {
                $scope.drawManyRoutesOnMap();
            });
        };

        $scope.showAll = function() {
            var promises = [];

            for (var i in $scope.trackObjects) {
                promises.push(
                    new Promise(function(resolve, reject) {
                        $scope.trackObjects[i].isShow = true;

                        resolve(true);
                    })
                );
            }
            Promise.all(promises).then(function() {
                $scope.drawManyRoutesOnMap();
            });
        };

        $scope.removeAll = function() {
            $scope.trackObjects = {};
            $scope.amounTrackObjects = 0;
            $scope.amounTrackObjects = 0;
            $scope.trackObjectsRouteSimple = {};
            $scope.trackObjectsPolyline = {};
            $scope.trackObjectsMarkers = {};
            USED_LABEL = [];
            $scope.clearMap();
            $scope.markers = [];
        };

        $scope.removeElem = function(object) {
            new Promise(function(resolve, reject) {
                USED_LABEL.splice(USED_LABEL.indexOf($scope.trackObjects[object.objectId].label), 1);
                delete $scope.trackObjects[object.objectId];
                delete $scope.trackObjectsRouteSimple[object.objectId];
                delete $scope.trackObjectsPolyline[object.objectId];
                delete $scope.trackObjectsMarkers[object.objectId];

                $scope.amounTrackObjects -= 1;

                resolve(true);
            }).then(function() {
                $scope.drawManyRoutesOnMap();
            });
        };

        /**
         * @TODO
         * remove it
         */
        $scope.drawRoutesForObject = function(object, draw) {
            var nowMoment = moment();
            var endMoment = moment(object.dateEnd);

            if (endMoment > nowMoment) {
                object.dateEnd = nowMoment.format('YYYY-MM-DD HH:mm:ss');
            }

            var settings = $scope.routeSettings;
            var endpoint = `/api/object/${object.objectId}/routeSimple`;

            return $http
                .get(endpoint, {
                    params: {
                        start: object.dateStart,
                        end: object.dateEnd,
                        minSpeed: settings.stops.minSpeed,
                        maxSpeed: settings.stops.maxSpeed,
                        filtering: settings.route.filtering,
                    },
                })
                .then(function(response) {
                    var routeData = response.data.data;

                    if (routeData.route.length == 0 && draw) {
                        USED_LABEL.splice(USED_LABEL.indexOf($scope.trackObjects[object.objectId].label), 1);
                        delete $scope.trackObjects[object.objectId];

                        $scope.amounTrackObjects -= 1;

                        toaster.pop(
                            'info',
                            $translate.instant('routes.messages.noDatas.title'),
                            $translate.instant('routes.messages.noDatas.body')
                        );

                        return false;
                    }

                    $scope.stops = routeData.stops;
                    $scope.routes = routeData.route;

                    var points = routeData.route.map(function(v) {
                        return {
                            lat: v.Y,
                            lng: v.X,
                            speed: v.VectorSpeed,
                            date: moment.utc(v.GpsTime),
                        };
                    });

                    var directions = new google.maps.Polyline({
                        path: points,
                        geodesic: true,
                        strokeOpacity: 0.5,
                        strokeWeight: 5,
                        strokeColor: object.color,
                        icons: [
                            {
                                repeat: $scope.getIconRepeatDensity(points.length),
                                icon: {
                                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                    scale: 4,
                                    strokeColor: object.color,
                                    strokeOpacity: 0.6,
                                    strokeWeight: 2,
                                    fillColor: object.color,
                                    fillOpacity: 0.6,
                                },
                            },
                        ],
                    });

                    $scope.trackObjectsRouteSimple[object.objectId] = routeData;
                    $scope.trackObjectsPolyline[object.objectId] = directions;
                    $scope.trackObjectsMarkers[object.objectId] = [];

                    for (var i = 0; i < routeData.stops.length; i++) {
                        var o = routeData.stops[i];
                        var marker = {
                            id: String.fromCharCode($scope.trackObjects[object.objectId].label + 65) + i,
                            messageId: o.messageId,
                            type: 'stop',
                            latitude: o.posY,
                            longitude: o.posX,
                            markerOptions: {
                                label: {
                                    text: String(i + 1),
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                    color: object.color,
                                },
                                icon: {
                                    path: google.maps.SymbolPath.CIRCLE,
                                    scale: 12,
                                    strokeColor: object.color,
                                    strokeOpacity: 0.6,
                                    strokeWeight: 5,
                                    fillOpacity: 0.0,
                                },
                            },
                        };

                        $scope.trackObjectsMarkers[object.objectId].push(marker);
                    }

                    draw && $scope.setZoomForObject(object);
                    draw && $scope.drawManyRoutesOnMap();

                    /*
                     * Display car position and angle on preview route
                     */
                    var last = $scope.routes[$scope.routes.length - 1];
                    $scope.createStopMarker(last.X, last.Y, last.VectorSpeed > 0, last.VectorAngle, false);
                });
        };

        $scope.setZoomForObject = function(object) {
            var route = $scope.trackObjectsPolyline[object.objectId];
            var bounds = new google.maps.LatLngBounds();
            var points = route.getPath().getArray();

            for (var i = 0; i < points.length; i++) {
                bounds.extend(points[i]);
            }

            for (var j in $scope.trackObjects) {
                $scope.trackObjects[j].isActual = false;
            }

            $scope.trackObjects[object.objectId].isActual = true;

            $scope.mapObject.fitBounds(bounds);
        };

        $scope.drawManyRoutesOnMap = function() {
            $scope.markers = [];
            $scope.clearMap();

            for (var j in $scope.trackObjects) {
                if (!$scope.trackObjects[j].isShow) {
                    continue;
                }

                var directions = $scope.trackObjectsPolyline[j];
                directions.setMap($scope.mapObject);
                $scope.mapOverlays.push(directions);

                for (var i = 0; i < $scope.trackObjectsMarkers[j].length; i++) {
                    $scope.markers.push($scope.trackObjectsMarkers[j][i]);
                }
            }
        };

        $scope.findLabelForObject = function() {
            if (USED_LABEL.indexOf($scope.amounTrackObjects - 1) === -1) {
                USED_LABEL.push($scope.amounTrackObjects - 1);

                return $scope.amounTrackObjects - 1;
            }

            for (var i = 0; i < MAX_AMOUNT_OBJECTS; i++) {
                if (USED_LABEL.indexOf(i) === -1) {
                    USED_LABEL.push(i);

                    return i;
                }
            }

            return -1;
        };

        $scope.mobileRotesListView = true;

        /* =====================================================================
         * Section: Route settings
         * =================================================================== */

        $scope.routeSettings = {
            stops: {
                minSpeed: 0,
                maxSpeed: 4,
            },
            route: {
                filtering: 1,
            },
        };

        $scope.openRouteSettingsModal = function() {
            $ngConfirm({
                title: $translate.instant('routes.settings.title'),
                contentUrl: 'tpl/pages/route/modals/settings.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-settings pe-lg pe-va',
                scope: $scope,
                buttons: {
                    ok: {
                        text: $translate.instant('routes.settings.ok'),
                        btnClass: 'btn-success',
                        action: function(scope) {
                            if (scope.routeSettingsFrom.$invalid) {
                                toaster.pop({
                                    type: 'error',
                                    title: $translate.instant('general.toastr.error.header'),
                                    body: $translate.instant('error.InvalidForm'),
                                });

                                return false;
                            }

                            return true;
                        },
                    },
                },
            });
        };

        var fireGoogleMapLoad = function(map) {
            /**
             * map object
             */
            $scope.mapObject = $scope.map.control.getGMap();

            /**
             * zones
             */
            if (
                !AccessManagerService.hasExtraFeature('zones-management') ||
                ['ww'].indexOf(DistributionService.code()) < 0
            ) {
                return;
            }

            $ctrl.zones = {};

            $ctrl.zones.list = {
                zones: false,
                groups: false,
            };

            $ctrl.zones.map = map;

            $ctrl.zones.getApiData = function(list, action) {
                var deferred = $q.defer();

                Microservice.interceptor('zone', 'get', '/' + action).then(function(response) {
                    var result = response.data ? response.data : [];

                    $ctrl.zones.list[list] = result;

                    deferred.resolve(result);
                }, deferred.reject);

                return deferred.promise;
            };

            $ctrl.zones.sd = new ZoneShapeDrawing(
                map,
                {
                    onChangeDrawingState: function() {},
                },
                $scope
            );

            $ctrl.zones.getApiData('zones', 'zones').then(function() {
                $ctrl.zones.getApiData('groups', 'zone-groups').then(function() {
                    $ctrl.zones.sgd = new ZoneShapeGroupDrawing(
                        $ctrl.zones.sd,
                        $ctrl.zones.list.zones,
                        $ctrl.zones.list.groups
                    );

                    $ctrl.zones.sgd.reload('groups', false);
                    $ctrl.zones.sgd.reload('zones', true);
                });
            });
        };

        /**
         * Controller init function
         */
        $scope.init = function() {
            $scope.gMapPromise();
            $scope.getObjects();
            $scope.getUserSettings();
        };
        $scope.init();
    },
]);

/**
 * Check if the given elements overlap
 * @param {DomElement} r1
 * @param {DomElement} r2
 * @returns {Boolean}
 */
function intersectRect(r1, r2) {
    return !(r2.left >= r1.right || r2.right <= r1.left || r2.top >= r1.bottom || r2.bottom <= r1.top);
}

function reversedIterator(itr) {
    var range = [];
    var index = 0;
    while (itr.hasNext()) {
        range.push(itr.next());
    }
    range = range.reverse();

    this.hasNext = function() {
        return index < range.length;
    };
    this.next = function() {
        return range[index++];
    };
    return this;
}
